import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { AttribuzioneDTO } from "@app/shared/dto/gescor/attribuzioneDTO";
import { AttribuzioneVO } from "@app/shared/vo/gescor/attribuzioneVO";
import { MapperUtente } from "../mapper-utente";
import { MapperMetaDatiCorrispondenza } from "./mapper-metadati-corrispondenza";

@Injectable({
  providedIn: "root"
})
export class MapperAttribuzioni
  implements MapperInterface<AttribuzioneDTO, AttribuzioneVO> {
  constructor(
    private mapperUtente: MapperUtente,
    private mapperMetadatiCorrispondenza: MapperMetaDatiCorrispondenza
  ) {}

  convertVoToDto(e: AttribuzioneVO): AttribuzioneDTO {
    throw new Error("Method not implemented.");
  }
  convertDtoToVo(t: AttribuzioneDTO): AttribuzioneVO {
    // console.log("[MapperAttribuzioni] AttribuzioneDTO => AttribuzioneVO", t);
    const attribuzioneVO = new AttribuzioneVO();

    attribuzioneVO.dataAttribuzione = t.dataAttribuzione;
    attribuzioneVO.dataEsito = t.dataEsito;
    attribuzioneVO.idCorrispondenza = t.idSmistamento;
    attribuzioneVO.dataPresaVisione = t.dataPresaVisione;
    attribuzioneVO.motivoRifiuto = t.motivoRifiuto;
    attribuzioneVO.estensore = this.mapperUtente.convertDtoToVo(t.estensore);
    attribuzioneVO.metadatiCorrispondenzaArrivo = this.mapperMetadatiCorrispondenza.convertDtoToVo(
      t.metadatiCorrispondenza
    );

    attribuzioneVO.id = t.id;
    attribuzioneVO.idCorrispondenza = t.idSmistamento;
    attribuzioneVO.stato = t.stato;

    return attribuzioneVO || new AttribuzioneVO();
  }
  convertListVoToDto(e: AttribuzioneVO[]): AttribuzioneDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: AttribuzioneDTO[]): AttribuzioneVO[] {
    const attribuzioneVOList = new Array<AttribuzioneVO>();
    if (t != null) {
      t.forEach(dto => {
        attribuzioneVOList.push(this.convertDtoToVo(dto));
      });
    }

    return attribuzioneVOList || new Array<AttribuzioneVO>();
  }
}
